import { useEffect, useState } from "react";
import TableTerms from "./TableTerms";
import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CgSpinner } from "react-icons/cg";

export default function Terms({ setData, initialState }) {
  const TermsData = initialState?.project_job_enquiry_term;
  const [allTerms, setAllTerms] = useState(TermsData);

  const [show, setShow] = useState(false);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      terms_and_conditions_edit: allTerms
        ?.filter((data) => data?.type != "new")
        ?.map((data) => ({
          terms_and_conditions_id: data?.id,
          particular: data?.particular,
          remark: data?.remark,
        })),
      terms_and_conditions_new: allTerms
        ?.filter((data) => data?.type == "new")
        ?.map((data) => ({
          particular: data?.particular,
          remark: data?.remark,
        })),
    }));
  }, [allTerms]);

  const addTerm = () => {
    const newTerm = {
      id: Math.floor(Math.random() * 1000),
      particular: "",
      remark: "",
      type: "new",
    };

    setAllTerms((prev) => [...prev, newTerm]);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 ">
        <div className="max-w-sm min-w-max  w-full flex gap-3 items-center h-fit">
          <button
            className="p-1 rounded-md ring-1 ring-slate-200"
            onClick={() => setShow((p) => !p)}
            type="button"
          >
            {show ? (
              <RiArrowDownSLine size={"1.4rem"} />
            ) : (
              <RiArrowRightSLine size={"1.4rem"} />
            )}
          </button>
          <div>
            <h2 className="font-semibold">Terms and condition</h2>
            <p>Provide Terms and condition.</p>
          </div>
        </div>
        <div
          className={`w-full overflow-hidden  px-4 rounded-md transition-all  ${
            show ? "h-auto py-4 ring-1 ring-slate-200 " : "h-0 overflow-hidden"
          }`}
        >
          <div className="flex justify-between p-3">
            <button
              type="button"
              className="bg-red text-white p-2 rounded-md mt-2 ml-2"
              onClick={addTerm}
            >
              + Add Another
            </button>
          </div>
          <TableTerms
            setData={setData}
            allTerms={allTerms}
            setAllTerms={setAllTerms}
          />
        </div>
      </div>
    </>
  );
}
